import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=6867009a&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=6867009a&prod&lang=scss"
import style1 from "./Wallet.vue?vue&type=style&index=1&id=6867009a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867009a",
  null
  
)

export default component.exports